import React from "react";
import { Box, Button, Typography } from "@mui/material";

import heroBackground from "../../../static/images/protone_pedals_bundle/hero-background.webp";
import { INCLUDED_PRODUCTS } from "./data";

const MainBanner = ({ children }: { children: React.ReactNode }) => (
  <Box component="section" aria-labelledby="protone-bundle-title" sx={{
    backgroundImage: `linear-gradient(90deg, rgba(13, 13, 13, 0.96), rgba(13, 13, 13, 0.82)), url(${heroBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    px: { xs: 3, sm: 5 },
    pt: { xs: 14, sm: 17 },
    pb: { xs: 7, sm: 10 },
  }}>
    <Box sx={{ maxWidth: "1280px", mx: "auto", display: "grid", gridTemplateColumns: { xs: "1fr", md: "0.9fr 1.1fr" }, gap: { xs: 5, md: 7 }, alignItems: "center" }}>
      <Box>
        <Button href="/store#bundles" size="small" sx={{ color: "#ddd", px: 0, mb: 2 }}>← Plugin Bundles</Button>
        <Typography sx={{ color: "#ddd", letterSpacing: "0.18em", textTransform: "uppercase", fontSize: "0.75rem", fontWeight: 650, mb: 1.5 }}>
          Overdrive + Boost + Fuzz
        </Typography>
        <Typography id="protone-bundle-title" variant="h1" sx={{ fontSize: { xs: "2.75rem", sm: "4rem" }, lineHeight: 1.08, fontWeight: 650 }}>
          ProTone Pedals Bundle
        </Typography>
        <Typography sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" }, mt: 2, mb: 2 }}>
          Three pedals. Your signature sound.
        </Typography>
        <Typography sx={{ color: "#d4d4d4", fontSize: "1rem", lineHeight: 1.8, maxWidth: "520px" }}>
          Dead Horse Overdrive, Cor Mid Boost and Monster Fuzz in one bundle.
          Tighten your attack, shape your mids and add a different kind of dirt to your rig.
        </Typography>
        {children}
        <Button href="#included-products" variant="text" sx={{ mt: 2, px: 0, color: "#ddd" }}>Explore the included plugins ↓</Button>
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: { xs: 2, sm: 3 }, minWidth: 0, alignItems: "end" }}>
        {INCLUDED_PRODUCTS.map((product) => <Box component="figure" key={product.id} sx={{
          m: 0,
          gridColumn: product.id === "protone-monsterfuzz" ? "1 / -1" : "auto",
          width: product.id === "protone-monsterfuzz" ? "80%" : "100%",
          justifySelf: "center",
        }}>
          <img src={product.image} alt={`${product.name} plugin interface`} width={product.width} height={product.height} loading="eager" decoding="async" style={{ display: "block", width: "100%", height: "auto", maxHeight: "280px", objectFit: "contain", filter: "drop-shadow(0 12px 24px rgba(0,0,0,0.5))" }} />
          <Typography component="figcaption" sx={{ mt: 1, textAlign: "center", fontSize: "0.8rem", color: "#ddd" }}>{product.name}</Typography>
        </Box>)}
      </Box>
    </Box>
  </Box>
);

export default MainBanner;
